// @flow
// @jsx h
import Vue from 'vue'
import store from 'app/store'
import DiscussionFooter from 'app/components/discussions/discussion-footer.vue'
import { router } from 'app/store'
import DiscussionsControls from 'app/components/discussions/discussions-controls.vue'

export const DiscussionFooterView = new Vue({
  components: {},
  store,
  beforeMount() {
    const { commit } = this.$store
    const { likeCount, entity, isLiked, authorId } = Laravel
    const id = entity ? entity.id : ''

    commit('setArticle', { likeCount, id, isLiked, authorId })
  },
  render(h) {
    return <DiscussionFooter />
  },
})

export const DiscussionsControlsView = new Vue({
  components: {},
  store,
  router,
  beforeMount() {
    // const { likeCount, id, isLiked } = Laravel
  },
  render(h) {
    return <DiscussionsControls />
  },
})
